<template>
    <div v-if="$slots.default">
        <slot />
        <hr class="my-2" v-if="!withoutBottomLine">
    </div>
</template>

<script>
export default {
    props: {
        withoutBottomLine: {
            type: Boolean,
            default: false
        },
    },
}
</script>

<style lang="scss" scoped>
hr {
    border: 0;
    height: 1px !important;
    background-color: #DFE2EB;
    color: red
}
</style>